import gql from 'graphql-tag';

export const getPayjpPublicKey = gql`
  query getPayjpPublicKey {
    getPayjpPublicKey(input: { empty: true }) {
      publicKey
    }
  }
`;
